module.exports = __webpack_public_path__ + "img/icon-setting-face-id.57b05307.svg";